/**
 * Job API Client
 * Encapsulates all API calls to job-related endpoints
 */

import { apiRequest } from './queryClient';
import type { JobStatusDTO } from '../types/job';

/**
 * Job API Client
 * Provides methods for job-related API operations
 */
export class JobClient {
  /**
   * Get the status of a specific job by ID
   */
  static async getJobStatus(jobId: string): Promise<JobStatusDTO> {
    const response = await apiRequest('GET', `/recipes/import-job/${jobId}`);
    return response.json();
  }
}


